import { useState } from 'react';
import useApiContext from '../../../hooks/useApiContext';

interface UseImageUploadResult {
  uploadImage: (file: File) => Promise<string>;
  isUploading: boolean;
  error: string | null;
}

export const useImageUpload = (): UseImageUploadResult => {
  const { mediaRepository } = useApiContext();
  const [isUploading, setIsUploading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const uploadImage = async (file: File): Promise<string> => {
    setIsUploading(true);
    setError(null);

    try {
      // Create FormData for file upload
      const formData = new FormData();
      formData.append('media', file);

      // Upload using MediaRepository
      const mediaResponse = await mediaRepository.upload(formData);

      // Return the appropriate image URL
      // Use w1024 for good quality while keeping file sizes reasonable
      return mediaResponse.w1024 || mediaResponse.original;
    } catch (err: any) {
      const errorMessage = err.message || 'Failed to upload image';
      setError(errorMessage);
      throw new Error(errorMessage);
    } finally {
      setIsUploading(false);
    }
  };

  return {
    uploadImage,
    isUploading,
    error,
  };
};
